import React, {useState} from 'react';
import PropTypes from 'prop-types';
import LanguageSelectDropdown from 'components/ui/language-select-dropdown/language-select-dropdown';
import LoginFacilitator from './user-login/login-facilitator';
import ResetPassword from './reset-password/reset-password';
import CreateUser from './create-user/create-user';
import LoginGroup from './user-login/login-group';
import './login.scss';

const Login = (props) => {
	/* Props */
	const {
		cookiesAccepted, 
		languageId,
		loginRole,
		deviceInfo, 
		toggleCookiePopup, 
		facilitatorLogin, 
		findGame, 
		createGroup, 
		getLoginToken, 
		loginWithToken,
		setLanguageId,
		calculateFontSize
	} = props;

	/* Facilitator action (login, create-user or reset-password) */
	const [facilitatorAction, setFacilitatorAction] = useState('login');

	/* Login component */
	let LoginComponent = LoginGroup;
	if (loginRole === 'facilitator') {
		LoginComponent = LoginFacilitator;
	}
	if (facilitatorAction === 'create-user') LoginComponent = CreateUser;
	if (facilitatorAction === 'reset-password') LoginComponent = ResetPassword;

	const handleSelectLanguage = (newLanguageId) => {
		setLanguageId(newLanguageId);
	};

	return (
		<div className={'Login ' + deviceInfo.orientation + ' ' + loginRole}>
			<LoginComponent 
				cookiesAccepted={cookiesAccepted}
				languageId={languageId}
				deviceInfo={deviceInfo}
				toggleCookiePopup={toggleCookiePopup}
				facilitatorLogin={facilitatorLogin}
				setFacilitatorAction={setFacilitatorAction}
				findGame={findGame}
				createGroup={createGroup}
				getLoginToken={getLoginToken}
				loginWithToken={loginWithToken}
				calculateFontSize={calculateFontSize}
			/>

			{/* Language */}
			<div className="Login-selectLanguage">
				<LanguageSelectDropdown 
					languageId={languageId}
					layout={loginRole}
					deviceInfo={deviceInfo}
					handleSelectLanguage={handleSelectLanguage}
				/>
			</div>
		</div>
	);
};

Login.propTypes = {
	cookiesAccepted: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	loginRole: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	toggleCookiePopup: PropTypes.func.isRequired,
	facilitatorLogin: PropTypes.func.isRequired,
	findGame: PropTypes.func.isRequired,
	createGroup: PropTypes.func.isRequired,
	getLoginToken: PropTypes.func.isRequired,
	loginWithToken: PropTypes.func.isRequired,
	setLanguageId: PropTypes.func.isRequired,
	calculateFontSize: PropTypes.func.isRequired,
};

export default Login;